<div class="content">
  <app-form-search></app-form-search>
  <app-offers-list></app-offers-list>
</div>
